import { useSelector } from "react-redux";
import PlaceholderImage from "../../products/PlaceholderImage";
import introBuilding from "../../../assets/smartbuilding/introSection/buildingIntro.jpg";
import dashboardImage from "../../../assets/smartbuilding/introSection/dashboard.png";

export default function IntroSection(props) {
  const { textContent, language } = { ...props };

  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="container">
      {!isMobile ? (
        <div className="split-wrapper-sb">
          <div className="split-grid-sb">
            <div className="split-item-sb textTopLeft-sb">
              <h1 className="title-gradient">
                {textContent.introSection.title[language]}
              </h1>
              <h2> {textContent.introSection.subtitle[language]}</h2>
            </div>

            <div className="split-item-sb image-sb">
              <img src={introBuilding} aria-hidden="true" />
            </div>
          </div>
          <div className="split-center-box-sb">
            <img src={dashboardImage} aria-hidden="true" />
          </div>
        </div>
      ) : (
        <div>
          <div className="container-small">
            <h1 className="title-gradient">
              {textContent.introSection.title[language]}
            </h1>
            <h2> {textContent.introSection.subtitle[language]}</h2>
          </div>
          <div className="container-empty-small" />
          <div className="split-grid-mobile-sb">
            <div className="split-item-image-sb-mobile">
              <img src={introBuilding} aria-hidden="true" />
            </div>
            <div className="split-center-box-sb-mobile">
              <img src={dashboardImage} aria-hidden="true" />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
